'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.isRelativePath = isRelativePath;
exports.getFirstOfType = getFirstOfType;
exports.Link = Link;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _ListItem = require('@material-ui/core/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _reactRouterDom = require('react-router-dom');

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Check if a string begins with `//`, `http://`, or `https://`
 * https://www.debuggex.com/r/YOT4v3GB0b677efd
 *
 * @param  {String} pathStr - URL to test
 * @return {Boolean}
 */
function isRelativePath(pathStr) {
  return pathStr && !/^(\/\/|https?:\/\/)/i.test(pathStr);
}

/**
 * Given a list of any React elements, return the first one that
 * matches the type passed in
 *
 * @param  {NodeList} components - list of components to search through
 * @param  {Object} type - React component
 * @return {Object|null}
 */


function getFirstOfType(children, type) {
  var res = null;

  React.Children.forEach(children, function (child) {
    if (child && child.type === type && res === null) {
      res = child;
    }
  });

  return res;
}

function Link(props) {
  var activeClassName = props.activeClassName,
      classes = props.classes,
      children = props.children,
      exact = props.exact,
      onClose = props.onClose,
      target = props.target,
      to = props.to,
      remainingProps = (0, _objectWithoutProperties3.default)(props, ['activeClassName', 'classes', 'children', 'exact', 'onClose', 'target', 'to']);


  var firstIconChild = getFirstOfType(children, _Icon2.default);
  var firstTextChild = getFirstOfType(children, _Text2.default);
  var iconChild = !!firstIconChild && firstIconChild;
  var textChild = !!firstTextChild && firstTextChild;

  /**
   * The Praxis `SideNav` component should support multiple
   * types of linking.
   *
   * In order to do so, `Link` extends `react-router-dom`s
   * `to` prop. It accepts either:
   *   - a string: https://reacttraining.com/react-router/web/api/Link/to-string
   *   - or an object: https://reacttraining.com/react-router/web/api/Link/to-object
   *
   * In addition to these two types, we also add the option
   * of adding external "absolute" links.
   *
   * When an external link is used, a traditional anchor
   * tag is rendered, so `to` *must* be a string.
   *
   * Acceptable types:
   *   | example                             |   component   |
   *   |-------------------------------------|---------------|
   *   | `"/1"`                              | `<NavLink />` |
   *   | { pathname: '/1', search: '?test' } | `<NavLink />` |
   *   | `http://target.com`                 | `<a />`       |
   */
  var spreadProps = typeof to === 'string' && !isRelativePath(to) ? {
    component: function component(muiProps) {
      return React.createElement(
        'a',
        muiProps,
        iconChild,
        textChild
      );
    },
    href: to,
    target: target
  } : {
    component: function component(muiProps) {
      return React.createElement(
        _reactRouterDom.NavLink,
        (0, _extends3.default)({
          activeClassName: activeClassName,
          exact: exact,
          to: to,
          onClick: function onClick() {
            return onClose();
          }
        }, muiProps),
        iconChild,
        textChild
      );
    }
  };

  return iconChild || textChild ? React.createElement(_ListItem2.default, (0, _extends3.default)({
    classes: classes,
    role: 'menuitem'
  }, spreadProps, remainingProps)) : null;
}

Link.defaultProps = {
  activeClassName: '',
  classes: {},
  exact: false,
  onClose: function onClose() {},
  target: '_blank'
};

exports.default = Link;